import { Record } from 'immutable';

const SurveysResponesRecord = new Record({
  survey: null,
  response: [],
});

class SurveysResponses extends SurveysResponesRecord {
  get id() {
    return this.get('survey');
  }
}

export default SurveysResponses;
